import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Container } from "react-bootstrap";
import { CAMPAIGN_METRICS_COLUMNS } from "./utils/campaignMetricsColumns";

import {
  emptyString,
  campaignMetricsConstants,
  CAMPAIGN_METRICS_LABELS,
  CAMPAIGN_METRICS_PAGINATION,
} from "../../constants";
import {
  useSpinner,
  Spinner,
  ExpandableTable,
  datePreferenceUtility,
  paginatedPostRequestBodyForCampaignMetrics,
  ReportTableSection,
} from "../../../../shared";
import { campaignMetricsActions } from "../../redux/actions";
import { storeActions } from "../../../admin-screens/redux/actions";
import Charts from "./charts";
import DatePicker from "./datePicker";

const expandTableRow = ({ data }) => <Charts data={data} />;

const CampaignMatrics = (props) => {
  const {
    getAllBrands,
    getCampaignMetricsData,
    getStoresAgainstBrandId,
    storesReducer: { allBrands, stores },
    campaignMetricsReducer: { campaignMetricsPagination, campaignMetricsData },
  } = props;

  //Initial states
  const [selectedBrand, setSelectedBrand] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [searchString, setSearchString] = useState(emptyString);
  const [dateState, setDateState] = useState(datePreferenceUtility());

  // set pagination details with request body
  const getPaginatedPostRequestBody = (pageNumber) => {
    return paginatedPostRequestBodyForCampaignMetrics(
      selectedLocation?.externalId,
      campaignMetricsPagination,
      pageNumber,
      searchString,
      dateState?.startDate,
      dateState?.endDate,
      campaignMetricsPagination.totalElements
    );
  };

  // get table data with pagination
  const getData = (pageNumber = null) => {
    const requestBody = getPaginatedPostRequestBody(pageNumber);
    getCampaignMetricsData(requestBody);
  };

  // Show loading while a request is running.
  const spinner = useSpinner();

  //Get data on first render and when change search field
  useEffect(() => {
    if (selectedLocation?.externalId) {
      getData(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchString, dateState, selectedLocation]);

  useEffect(() => {
    getAllBrands(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <DatePicker
        stores={stores}
        spinner={spinner}
        dateState={dateState}
        allBrands={allBrands}
        setDateState={setDateState}
        selectedBrand={selectedBrand}
        setSelectedBrand={setSelectedBrand}
        selectedLocation={selectedLocation}
        setSelectedLocation={setSelectedLocation}
        getStoresAgainstBrandId={getStoresAgainstBrandId}
      />

      <Container fluid className="pb-3">
        <ReportTableSection
          title={CAMPAIGN_METRICS_LABELS.TABLE_TITLE}
          searchString={searchString}
          setSearchString={setSearchString}
        >
          {spinner(campaignMetricsConstants.CAMPAIGN_METRICS_SPINNER) ? (
            <Spinner />
          ) : (
            <div className="px-4">
              <ExpandableTable
                perPage={CAMPAIGN_METRICS_PAGINATION.PAGE_SIZES}
                columns={CAMPAIGN_METRICS_COLUMNS}
                expandOnRowClicked
                data={campaignMetricsData}
                keyField={CAMPAIGN_METRICS_LABELS.TABLE_KEY}
                handlePageChange={(pageNum) => {
                  getData(pageNum);
                }}
                expandRowRenderer={expandTableRow}
                pageNumber={campaignMetricsPagination.pageNumber + 1}
                totalRows={campaignMetricsPagination.totalElements}
                numberOfRowsPerPage={campaignMetricsPagination.pageSize}
              />
            </div>
          )}
        </ReportTableSection>
      </Container>
    </>
  );
};

const mapStateToProps = (state) => ({
  storesReducer: state.storesReducer,
  campaignMetricsReducer: state.campaignMetricsReducer,
});

const mapDispatchToProps = (dispatch) => ({
  getCampaignMetricsData: (body) =>
    dispatch(campaignMetricsActions.getCampaignMetricsData(body)),
  getAllBrands: (isActiveOnly) =>
    dispatch(storeActions.getAllBrands(isActiveOnly)),
  getStoresAgainstBrandId: (brandId) =>
    dispatch(storeActions.getStoresAgainstBrandId(brandId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(CampaignMatrics));
